import { Component, HostBinding, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../field.interface";
@Component({
  selector: "app-select",
  template: `
      <div class="row">
        <mat-form-field class="col-12 demo-full-width margin-top" [formGroup]="group">
        <mat-select [placeholder]="field.label" [formControlName]="field.name"  (blur)="blur(group)"  (input)="valueChangeCallbackModal(group)">
        <mat-option *ngFor="let item of field.options" [value]="item">{{item[field.description]}}</mat-option>
        </mat-select>
        </mat-form-field>
    </div>
`,
  styleUrls: ["./select.component.scss"],
})
export class SelectComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  @HostBinding('class') class = '';
  @Input() blur: (args: any) => void;
  @Input() valueChangeCallbackModal: (args: any) => void;
  constructor() {
  }
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
    this.blur = this.field.blur ? this.field.blur : this.funcionAuxNothing;
    this.valueChangeCallbackModal = this.field.valueChangeCallbackModal ? this.field.valueChangeCallbackModal : this.funcionAuxNothing;
    if (this.field.value) {
      let valorSeleccionado = this.field.options?.filter(option => option.id === this.field.value.id)[0]
      this.group.controls[this.field.name].patchValue(valorSeleccionado);
    }
  }

  funcionAuxNothing() {
    //no hace nada solo para que no pinche el blur
  };

}
